
export type GetAllUsers500 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
